export default __webpack_public_path__ + "static/runtime@2x-b97f86c6de1d72919faeebd195bcde39.png";